export const CONFIG_NAME = 'glympse-pro.v2';
export const JOURNEY_APP_HEADER_LOGO = 'widgets.headerWidget.logoUrl';
export const JOURNEY_AGENT_LABEL_PATH = 'locales.en.driverWidget.agentTitle';
export const JOURNEY_TASK_LABEL_PATH = 'locales.en.orderWidget.appointmentType';

export const JOURNEY_APP_PRIMARY_COLOR = 'theme.appPrimaryColor';
export const JOURNEY_APP_SECONDARY_COLOR = 'theme.appSecondaryColor';

export const JOURNEY_DESTINATION_ICON_TYPE = 'theme.destinationIconType';
export const JOURNEY_DESTINATION_ICON_URL = 'theme.destinationIcon.url';

export const JOURNEY_FEEDBACK_WIDGET_ENABLED = 'generalConfiguration.feedbackWidgetEnabled';

export const ORGANIZATION_PROOF_OF_DELIVERY = 'tasks.image_upload';

export const ORGANIZATION_CHAT_ENABLE= 'phases.types';
export const JOURNEY_CHAT_ENABLE = 'generalConfiguration.chatWidgetEnabled';
export const JOURNEY_CHAT_PHASES = 'widgets.chatWidget.phases';

export const JOURNEY_VEHICLE_VAN_IMAGE = 'theme.agentIcon.vehicle.custom';
export const JOURNEY_VEHICLE_LOGO_IMAGE = 'theme.vehicleBrandingIcon';
export const JOURNEY_VEHICLE_TYPE = 'theme.agentIcon.vehicleType';

export const JOURNEY_FEEDBACK_REVIEW_LINK = 'widgets.feedbackWidget.reviewLink';
export const JOURNEY_FEEDBACK_REVIEW_LINK_TITLE = 'widgets.feedbackWidget.reviewType';
export const JOURNEY_FEEDBACK_REVIEW_LINK_TEXT = 'locales.en.feedbackWidget.reviewLinkText';

export const JOURNEY_CONFIRMATION_PHOTO_LABEL = 'locales.en.feedbackWidget.viewConfirmationPhotoButtonLabel';
export const JOURNEY_CONFIRMATION_LOCALES = 'locales';

export const JOURNEY_ORG_ICON = 'theme.orgIcon.url';

export const JOURNEY_AD_CAROUSEL_ENABLE = 'widgets.adCarouselWidget.enabled';
export const JOURNEY_AD_CAROUSEL_ADS = 'widgets.adCarouselWidget.ads';
export const JOURNEY_AD_CAROUSEL_LOCALES = 'locales.en.adCarouselWidget';

export const JOURNEY_PHASES= 'phases';
